// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2Js_3","spin":"Spinner_spin__PTx8K","container":"Spinner_container__1QLn5"};